import { allAssociadoProfileIds, allAssessorProfileIds, allProfileIds } from "library/AuthProfile";
import { AuthUserPerfilId, IAuthUserPerfil } from "store/modules/auth/IAuthUserPerfil";
import PerfilAssociado from "store/modules/auth/PerfilAssociado";
import PerfilAssociadoConvidado from "store/modules/auth/PerfilAssociadoConvidado";
import PerfilDeslogado from "store/modules/auth/PerfilDeslogado";
import PerfilAssessorAdmin from "store/modules/auth/PerfilAssessorAdmin";
import PerfilAssessorConsulta from "store/modules/auth/PerfilAssessorConsulta";
import PerfilAssessorGestao from "store/modules/auth/PerfilAssessorGestao";

export const isAssessorProfile = (profile: IAuthUserPerfil): boolean => {
  return allAssessorProfileIds.indexOf(profile.id) > -1;
}

export const isAssociadoProfile = (profile: IAuthUserPerfil): boolean => {
  return allAssociadoProfileIds.indexOf(profile.id) > -1;
}

export const getProfileById = (id: AuthUserPerfilId): IAuthUserPerfil | null => {
  switch(id) {
    case AuthUserPerfilId.AssessorAdmin:
      return PerfilAssessorAdmin;
    case AuthUserPerfilId.AssessorGestao:
      return PerfilAssessorGestao;
    case AuthUserPerfilId.AssessorConsulta:
      return PerfilAssessorConsulta;
    case AuthUserPerfilId.Associado:
      return PerfilAssociado;
    case AuthUserPerfilId.AssociadoConvidado:
      return PerfilAssociadoConvidado;
    case AuthUserPerfilId.Deslogado:
      return PerfilDeslogado;
    default:
      return null;
  }
}

export const getProfileByIds = (ids: AuthUserPerfilId[]): IAuthUserPerfil | null => {
  const foundProfiles: AuthUserPerfilId[] = allProfileIds.filter((id: AuthUserPerfilId): boolean => {
    if (ids.indexOf(id) > -1) {
      return true;
    }
    return false;
  });
  if (foundProfiles.length === 1) {
    return getProfileById(foundProfiles[0]);
  }
  if (foundProfiles.includes(AuthUserPerfilId.AssessorAdmin)) {
    return getProfileById(AuthUserPerfilId.AssessorAdmin);
  }
  if (foundProfiles.includes(AuthUserPerfilId.AssessorGestao)) {
    return getProfileById(AuthUserPerfilId.AssessorGestao);
  }
  if (foundProfiles.includes(AuthUserPerfilId.AssessorConsulta)) {
    return getProfileById(AuthUserPerfilId.AssessorConsulta);
  }
  return null;
};

export const getProfileByJWTRoles = (roles: string[]): IAuthUserPerfil | null => {
  if (roles.length > 0) {
    return getProfileByIds(
      roles.map(
        (role: string): string => {
          if (role.indexOf('/') > -1) {
            return role.split('/')[1];
          }
          return role;
        }
      ).filter(
        (role: string): boolean => {
          if ((allProfileIds as string[]).indexOf(role) > -1) {
            return true
          }
          return false;
        }
      ) as AuthUserPerfilId[]
    );
  }
  return null;
}